<template>
    <v-container class="justify-center">
        <v-dialog v-show="loading">
            <v-card>
                <span>trwa ładowanie contentu</span>
            </v-card>
        </v-dialog>
        <v-row class="justify-center" :disabled="disabled">
            <h1>{{ seasonView }}</h1>
        </v-row>
        <!-- <v-row>
            <v-col cols="12">
                <v-input>
                    <v-text-field type="text" v-model="searchLeague" label="Search league name" append-icon="search"></v-text-field>
                </v-input>  
            </v-col>
        </v-row> -->
        <v-row class="justify-center" >
            <v-col cols="12" sm="12" md="6" lg="4"
            v-for="(item,index) in leagues"
            :key="index"
            >
                <v-hover v-slot:default="{ hover }">
                    <v-card
                    class="mx-auto"
                    max-width="400"
                    min-height="450"
                    >
                        <!-- card hovers -->
                        <v-expand-transition>
                            <div 
                                v-if="hover && item.avaibleSpots"
                                style="background-color: rgba(118,235,108,0.4);"
                                class="cardHover cardBlurGreen d-flex transition-fast-in-fast-out v-card--reveal display-2 white--text"
                            >
                                <v-btn 
                                class="ma-auto white--text"
                                color="#76EB6C"
                                link
                                large
                                @click="go(item.leagueId)"
                                >
                                    Sprawdź
                                <v-icon right>touch_app</v-icon>
                                </v-btn>
                            </div>
                            <div
                                v-if="hover && !item.avaibleSpots"
                                style="background-color: rgba(255,87,82,0.4);"
                                class="cardHover cardBlurRed d-flex transition-fast-in-fast-out v-card--reveal display-2 white--text"
                            >
                                <v-btn 
                                class="ma-auto white--text" 
                                color="#FF5752"
                                link
                                large
                                @click="go(item.leagueId)"
                                >
                                    Brak miejsc
                                <v-icon right>block</v-icon>
                                </v-btn>
                            </div>
                        </v-expand-transition>
                        <!-- tytul -->
                        <v-row class="no-gutters">
                            <v-col cols="12" sm="12">
                                <v-img :src="item.leagueBanner" height="100"></v-img>
                            </v-col>
                        </v-row>
                        <!-- headline -->
                        <v-row class="no-gutters">
                            <v-col cols="12" sm="12">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title class="headline text-center text-uppercase">{{ item.leagueName }}</v-list-item-title>
                                        <v-list-item-subtitle class="mt-2 mb-2 ml-2">Organizator: <span class="text-uppercase">{{ item.leagueAdmin }}</span></v-list-item-subtitle>
                                        <p class="text-uppercase red--text text-center mb-1 mt-2 spotsInfo"><span  v-if="!item.avaibleSpots">BRAK WOLNYCH MIEJSC</span></p>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>
                        </v-row>
                        <!-- znaczniki -->
                        <v-row class="no-gutters">
                            <v-col cols="12" sm="12" md="6">
                                <v-card-text>
                                    <p class="">Ilość imprez: {{ item.racesAmount }}</p>
                                    <p class="">Ilość lokalizacji: {{ item.localizationsAmount }}</p>
                                </v-card-text>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-card-text>
                                    <p class="">Season pass: <v-icon :class="{greenColor: item.seasonPass, redColor: !item.seasonPass}">{{ item.seasonPass ? 'check_circle' : 'cancel' }}</v-icon></p>
                                    <p class="">Grand Prix:  <v-icon :class="{greenColor: item.seasonGrandPrix, redColor: !item.seasonGrandPrix}">{{ item.seasonGrandPrix ? 'check_circle' : 'cancel' }}</v-icon></p>
                                </v-card-text>
                            </v-col>
                        </v-row>
                        <!-- mapka -->
                        <v-row class="no-gutters">
                            <v-col cols="12" sm="12">
                                <div height="200" width="100%" class="text-center"> 
                                    <l-map
                                    :zoom="zoom"
                                    :center="center"
                                    style="height: 200px; width: 100%"
                                    >
                                    <l-tile-layer :url="url" :attribution="attribution"/>
                                    <l-marker v-for="place in item.races" :key="place.raceId" :lat-lng="place.location">
                                    </l-marker>
                                    </l-map>
                                </div>
                            </v-col>
                        </v-row>
                        <!-- <v-card-text>
                            <p class="text-uppercase red--text text-center" v-if="!item.avaibleSpots">BRAK WOLNYCH MIEJSC</p>
                            <p class="ml-2">Ilość imprez: {{ item.racesAmount }}</p>
                            <p class="ml-2">Ilość lokalizacji: {{ item.localizationsAmount }}</p>
                            <p class="ml-2">Season pass: <v-icon :class="{greenColor: item.seasonPass,redColor: !item.seasonPass}">{{ item.seasonPass ? 'check_circle' : 'cancel' }}</v-icon></p>
                            <p class="ml-2">Season Grand Prix:  <v-icon :class="{greenColor: item.seasonGrandPrix,redColor: !item.seasonGrandPrix}">{{ item.seasonGrandPrix ? 'check_circle_outline' : 'cancel' }}</v-icon></p>
                        </v-card-text> -->
                        <!-- <v-card-actions>
                            <v-btn 
                                text
                                @click="item.leagueDescription = !item.leagueDescription"
                            >
                            <v-icon>{{ item.leagueDescription ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
                                Read Description
                            </v-btn>
                            <v-spacer/>
                            <v-btn 
                                text
                                link
                                @click="go(item.leagueId)"
                            >
                                Go to league
                            </v-btn>
                        </v-card-actions>
                        <v-expand-transition>
                            <div v-show="item.leagueDescription">
                                <v-divider/>
                                <v-card-text>{{ item.description }}</v-card-text>
                            </div>
                        </v-expand-transition> -->
                    </v-card>
                </v-hover>
            </v-col>
        </v-row>
        <v-snackbar v-model="snackbar">
            {{ loginInfo }}
            <v-btn
                color="#76EB6C"
                text
                timeout="1500"
                @click="snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>
    </v-container>
</template>
<style>
    .spotsInfo{
        min-height:16.67px;
    }
    .cardHover{
        position:absolute; 
        height: 100%;
        width:100%; 
        z-index:999;
    }
    .greenBackgroundCard{
        background-color: rgba(118,235,108,0.4)!important;
    }
    .redBackgroundCard{
        background-color: rgba(255,87,82,0.4)!important;
    }
    .cardBlurGreen{
        box-shadow: inset 0 0 0.3em 0.005em gold, 0 0 0.3em 0.005em #76EB6C;
    }
    .cardBlurRed{
        box-shadow: inset 0 0 0.3em 0.005em gold, 0 0 0.3em 0.005em #FF5752;
    }
    .greenColor{
        color:#76EB6C !important;
    }
    .redColor{
        color:#FF5752 !important;
    }
</style>
<script>
import { LMap, LTileLayer, LMarker} from 'vue2-leaflet';
export default {
    name:'seasonOverView',
    components: {
        LMap,
        LTileLayer,
        LMarker
    },
    data(){
        return{
        zoom:5,
        center: [52.227140, 19.611421],
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        seasonView: 'Sezon 2020',
        currentPlace:null,
        loading:false,
        disabled:false,
        loginInfo:'Prawidłowe logowanie',
        snackbar:false,
        }
    },
    // beforeEnter(to,from,next){
    //     // if(to.meta.requireAuth){
    //       if(this.$store.state.token !=null && this.$store.state.stan==='zalogowano') {
    //          next()
    //       } else next({ name:'login' });
    //     // }
    //       // } else{ next({name:'login'})}
    // },
    computed:{
        leagues(){
            return this.$store.getters.getLeagues;
        },
        filtredItem(){
            return this.getSeasonOverView.filter( item => {
                return item.leagueName.match(this.searchLeague.toLowerCase());
            });
        }
    },
    methods:{
        go(leagueId){
            this.$router.push({ name:'league', params:{league_id: leagueId}});
        }
    },
    mounted(){
        this.snackbar=true;
        this.disabled=true;
        this.loading = true;
        if(this.$store.state.leagues.length==0){
            this.$store.dispatch('fetchLeaguesData')
            setTimeout(()=>{
                this.disabled=false;
                this.loading=false;
            },100)
        }            
    }

}
</script>